import { trpc } from '@/shared/api/trpc';

// Vote/unvote a similar ticket instead of filing a duplicate. Invalidates
// every read the vote count + hasVoted flag appears in.
export const useToggleVote = () => {
  const utils = trpc.useUtils();
  return trpc.support.toggleVote.useMutation({
    onSuccess: () => {
      utils.support.searchSimilar.invalidate();
      utils.support.recentList.invalidate();
      utils.support.myUnresolvedCount.invalidate();
      utils.support.myList.invalidate();
    },
  });
};
